<template>
  <div class="image-with-caption">
    <epi-picture
      v-edit="'Image'"
      :image="image"
      :use-picture="true"
      auto-quality="best"
      :sizes="dimensions"
    />
    <p
      v-edit="'Caption'"
      class="caption"
      v-text="caption"
    />
  </div>
</template>

<script>
  export default {
    name: "WideImageBlock",
    props: {
      image: {
        type: Object,
        default: () => {}
      },
      caption: {
        type: String,
        default: ""
      }
    },
    data () {
      return {
        dimensions: {
          small: {
            width: 734
          },
          medium: {
            width: 799
          },
          large: {
            width: 821
          }
        },
      }
    }
  }
</script>

<style lang="scss">
  .image-with-caption {
    margin: 0 0.5rem 3rem;

    @include media-breakpoint-up(md) {
      margin: 0 0 3rem;
    }

    & .epi-picture {
      margin-bottom: 0.5rem;

      picture,
      img {
        border-radius: 0.25rem;
        margin: 0;
        padding: 0;
        width: 100%;
      }
    }

    .caption {
      margin: 0;
      color: $color-grey-mid;

      @include font(text, 1, "normal");
    }
  }
</style>
